import { toast } from "./toast";
import * as firebase from "firebase";
const config = {
  apiKey: "AIzaSyCyWqM7KU5Yx-NDmnZaIWwhpbJ5AQeXXtM",
  authDomain: "math-help-home.firebaseapp.com",
  databaseURL: "https://math-help-home.firebaseio.com",
  projectId: "math-help-home",
  storageBucket: "math-help-home.appspot.com",
  messagingSenderId: "493282790513",
  appId: "1:493282790513:web:38460937464f7f76645fd0",
  measurementId: "G-706CB8341S",
};

firebase.initializeApp(config);

export function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        resolve(user);
      } else {
        resolve(null);
      }
      unsubscribe();
    });
  });
}

export function logoutUser() {
  return firebase.auth().signOut();
}

export async function loginUser(username: string, password: string) {
  const email = `${username}@mathhelphome.com`;
  try {
    const res = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password);

    return res;
  } catch (error) {
    toast(error, 4000);
    return false;
  }
}

export async function registerUser(username: string, password: string) {
  const email = `${username}@mathhelphome.com`;
  try {
    const res = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password);
    console.log(res);
    return true;
  } catch (error) {
    toast(error.message, 4000);
    return false;
  }
}
